export class Analytics {
	static convert(cart) {
		let data = null;

		if (cart != null && cart.offers != null && cart.offers.length > 0) {
			let items = [];

			for (let i = 0; i < cart.offers.length; i++) {
				items = items.concat(this.convertOffers(cart.offers[i]));
			}

			if (items != null && items.length > 0) {
				data = {};
				data.items = items;
				data.redirectCart = false;
				data.total = cart.totalPrice;
				data.isOnlyEquipments = true;
				data.isOnlyServices = false;
			}
		}

		return data;
	}

	static convertOffers(cartOffer) {
		let data = [];

		if (cartOffer != null) {
			if (cartOffer.cartOffers != null && cartOffer.cartOffers.length > 0) {
				for (var i = 0; i < cartOffer.cartOffers.length; i++) {
					data = data.concat(this.convertOffers(cartOffer.cartOffers[i]));
				}
			}

			if (cartOffer.cartItems != null && cartOffer.cartItems.length > 0) {
				for (var i = 0; i < cartOffer.cartItems.length; i++) {
					const cartItem = cartOffer.cartItems[i];

					if (cartItem != null && cartItem.price > 0 && cartItem.category != null) {
						const dataItem = {};

						dataItem.Code = cartItem.color != null ? cartItem.color.sapCode : "";
						dataItem.Name = cartItem.name;
						dataItem.Category = cartItem.category;
						dataItem.Brand = cartItem.name.split(" ")[0];
						dataItem.Color = cartItem.color != null ? cartItem.color.name : "";
						dataItem.UnitPrice =
							cartItem.price / (cartItem.amount > 0 ? cartItem.amount : 1);
						dataItem.DiscountedUnitPrice =
							cartOffer.price / (cartItem.amount > 0 ? cartItem.amount : 1);
						dataItem.Quantity = cartItem.amount;
						dataItem.Image = cartOffer.imageUrl;
						dataItem.DiscountValue =
							dataItem.UnitPrice - dataItem.DiscountedUnitPrice;
						dataItem.ProductId = cartItem.id;

						data.push(dataItem);
					}
				}
			}
		}

		return data;
	}

	static convertModify(cart, id, prevAmount, amount) {
		let data = null;

		if (cart != null && cart.offers != null && cart.offers.length > 0) {
			const offer = cart.offers.find((offer) => offer.internalId == id);
			const items = this.convertOffers(offer);

			const calculatedAmount = parseInt(amount) - parseInt(prevAmount);

			for (let i = 0; i < items.length; i++) {
				items[i].Quantity = Math.abs(calculatedAmount);
				items[i].Action = calculatedAmount >= 0 ? "add" : "remove";
			}

			if (items != null && items.length > 0) {
				data = {};
				data.items = items;
				data.redirectCart = false;
				data.total = cart.totalPrice;
				data.isOnlyEquipments = true;
				data.isOnlyServices = false;
			}
		}

		return data;
	}

	static publishCart(cart) {
		if (typeof BusinessAnalytics != "undefined") {
			const data = this.convert(cart);
			if (data != null) {
				BusinessAnalytics.CartLoadCompleted(data);
				BusinessAnalytics.CartPageLoad(data);
			}
		}
	}

	static getCart(cart) {
		this.publishCart(cart);
	}

	static removeFromCart(cart) {
		this.publishCart(cart);
	}

	static modifyCart(cart, id, prevAmount, amount) {
		if (typeof BusinessAnalytics != "undefined") {
			const data = this.convertModify(cart, id, prevAmount, amount);
			if (data != null) {
				BusinessAnalytics.CartUpdate(data);
			}
		}
		this.publishCart(cart);
	}

	static addToCart(cart) {
		this.publishCart(cart);
	}
}
